import $ from "cash-dom";

const component = (function () {
    $(document).ready(function () {
        var isScrolling = false;
        var scrollTimer;
        var delay = 50;
        var y;
        var py = 0;
        var currentDirection = "down";
        var previousDirection = "down";
        var directionChange;

        window.addEventListener("scroll", function () {
            if (!isScrolling) {
                isScrolling = true;
                y = window.scrollY;
                currentDirection = y < py ? "up" : "down";
                directionChange = currentDirection != previousDirection;

                if (directionChange) {
                    window.dispatchEvent(new CustomEvent("scrollDirectionChange", { detail: currentDirection }));
                }
            }

            clearTimeout(scrollTimer);

            scrollTimer = setTimeout(function () {
                isScrolling = false;
                py = window.scrollY;
                previousDirection = currentDirection;
            }, delay);
        });
    });
})();

export default component;
